var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-container"},[_vm._l((_vm.addressList),function(item,index){return _c('c-address',{key:index,attrs:{"address":item}})}),_c('c-new-address')],2)}
var staticRenderFns = []

export { render, staticRenderFns }